<template>
  <i
    :class="['iconfont', `icon-${name}`]"
    :style="{
      fontSize: normalizedSize,
      color: normalizedColor,
    }"
  ></i>
</template>

<script setup lang="ts">
import { computed } from "vue";

// 运行时 px 转 rem（与 postcss-pxtorem rootValue: 75 保持一致）
const pxToRem = (px: number) => `${px / 75}rem`;

const props = defineProps({
  name: String,
  size: [String, Number],
  color: String, // 可以是 var(--xxx) / #xxx / rgb()
});

const normalizedSize = computed(() => {
  if (!props.size) return undefined;
  // 如果是数字，转换为 rem；如果是字符串（可能已带单位），直接使用
  return typeof props.size === "number" ? pxToRem(props.size) : props.size;
});

// color 完全交给调用方，不做任何主题绑定
const normalizedColor = computed(() => props.color);
</script>
<style scoped>
.iconfont {
  display: inline-block;
  font-size: 22px;
  line-height: 1; /* 图标更紧凑 */
  vertical-align: middle; /* 与文字对齐更自然 */
  speak: none;
}
</style>
